export const concatBaseWithVersion = ({ base }) => {
  return base;
};
